import { cn, Stack } from 'component-library';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { TabsList, TabTrigger } from '@/components/Tabs/Tabs';
import { isNullish } from '@/utils/booleans';

type Tab = {
  label: string;
  description?: string;
  path: string;
  routeSlug: string;
  content?: React.ReactNode;
  default?: boolean;
  styles?: Record<string, string>;
};

export const Tabs = ({ tabs, styles }: { tabs: Tab[]; styles?: Record<string, string> }) => {
  if (isNullish(tabs)) return null;
  if (tabs.length === 0) return null;

  const defaultTab = tabs.find((tab) => tab.default) ?? tabs[0];

  return (
    <div className={cn('flex flex-col w-full', styles?.root)}>
      <TabsList className={cn('border-b border-divider', styles?.tabsList)}>
        {tabs.map((tab) => (
          <TabTrigger key={tab.routeSlug} path={tab.path} className={cn(styles?.tab, tab.styles?.tab)}>
            <Stack className={cn('items-center justify-center gap-1', styles?.tabTrigger, tab.styles?.tabTrigger)}>
              <span className={cn('typography-body1', styles?.tabLabel, tab.styles?.tabLabel)}>{`${tab.label}`}</span>
              <span
                className={cn(
                  'typography-body2 text-text-secondary font-normal',
                  styles?.tabDescription,
                  tab.styles?.tabDescription,
                )}
              >
                {tab.description ?? ''}
              </span>
            </Stack>
          </TabTrigger>
        ))}
      </TabsList>

      <div className={cn('mt-6', styles?.content)}>
        <Routes>
          <Route index element={<Navigate to={defaultTab?.routeSlug ?? ''} replace />} />
          {tabs.map((tab) => (
            <Route key={tab.routeSlug} path={tab.routeSlug} element={tab.content} />
          ))}
        </Routes>
      </div>
    </div>
  );
};
